import * as React from 'react';

interface ITabProps {
  onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
}

interface ITabState {}

export default class Tab extends React.Component<ITabProps, ITabState> {
  render() {
    return <div>{this.props.children}</div>;
  }
}
